<template>
  <button-base class="email"
               :title="i18n.t('public.social.share_on_email')"
               medium="email"
               @click="handleClick">
    <template #icon>
      <img src="@/images/icons/mail.svg" class="share-icon mail-icon">
    </template>
  </button-base>
</template>

<script>
import ButtonBase from './button-base'
import EmailMixin from '@/share/campaign/email-mixin'

export default {
  components: { ButtonBase },

  mixins: [EmailMixin]
}
</script>

<style scoped lang="scss">
// Override height to avoid squeezing the image
.share-icon {
  height: auto;
}
</style>
